var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { propTypes } from './types';
import './NxModal.scss';
var currentModalCloseHandlers = [];
var NxModal = function (_a) {
    var className = _a.className, onClose = _a.onClose, variant = _a.variant, role = _a.role, attrs = __rest(_a, ["className", "onClose", "variant", "role"]);
    var modalClasses = classnames('nx-modal', className, {
        'nx-modal--wide': variant === 'wide',
        'nx-modal--narrow': variant === 'narrow'
    }), dialogRef = useRef(null);
    var modalCloseListener = function (_a) {
        var key = _a.key;
        var isKeyPressedEscape = key === 'Escape' || key === 'Esc';
        if (isKeyPressedEscape && currentModalCloseHandlers.length) {
            currentModalCloseHandlers[currentModalCloseHandlers.length - 1]();
        }
    };
    var removeCloseHandlerListener = function () {
        var idx = currentModalCloseHandlers.indexOf(onClose);
        currentModalCloseHandlers.splice(idx, 1);
        if (!currentModalCloseHandlers.length) {
            document.removeEventListener('keydown', modalCloseListener);
        }
    };
    useEffect(function () {
        if (!currentModalCloseHandlers.length) {
            document.addEventListener('keydown', modalCloseListener);
        }
        currentModalCloseHandlers.push(onClose);
        return removeCloseHandlerListener;
    }, [onClose]);
    useEffect(function () {
        if (dialogRef.current) {
            var el = dialogRef.current;
            /*
             * This will cause the document to become "blocked by the modal dialog"
             * (https://html.spec.whatwg.org/multipage/interaction.html#blocked-by-a-modal-dialog)
             * meaning that only the modal and its contents are interactable/focusable.
             *
             * Note: not supported in safari, which is why the conditional is here. Once safari gets
             * it together, we should be able to take advantage of the "top layer" functionality built into
             * the browser around modals to simplify the NxModal styling around z-index handling
             */
            if (el.showModal) {
                el.showModal();
            }
        }
    }, []);
    return (
    // Note: role="dialog" should be redundant but I think some screenreaders (ChromeVox) don't know
    // what a <dialog> is.  It makes a difference there.
    React.createElement("dialog", { ref: dialogRef, role: role || 'dialog', "aria-modal": "true", className: "nx-modal-backdrop" },
        React.createElement("div", __assign({ className: modalClasses }, attrs))));
};
NxModal.propTypes = propTypes;
export default NxModal;
//# sourceMappingURL=NxModal.js.map